export const staircaseConfig = {
    gameSlug: 'minds-eye',
    category: 'terre_navigation',
    variable: 'duration_ms',
    startValue: 1200,
    minValue: 400,
    maxValue: 2000,
    stepSizesByPhase: [200, 100, 50, 25],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    maxTrials: 28,
    direction: 'down-easier',
};
export const SHAPES_SIMPLE = ['F', 'R'];
export const SHAPES_ALL = [
    'F',
    'R',
    'P',
    'L',
    'J',
    'G',
];
/** Angles de rotation possibles, par pas de 30°. */
export const ROTATIONS_NONE = [0];
export const ROTATIONS_BASIC = [0, 90, 180, 270];
export const ROTATIONS_FULL = [
    0, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330,
];
function buildVariant(level) {
    if (level <= 10) {
        return {
            level,
            shapes: SHAPES_SIMPLE,
            rotations: ROTATIONS_BASIC,
            mirrorRatio: 0.5,
            label: 'Lettres simples',
        };
    }
    if (level <= 20) {
        return {
            level,
            shapes: SHAPES_ALL,
            rotations: ROTATIONS_BASIC,
            mirrorRatio: 0.5,
            label: 'Formes abstraites',
        };
    }
    if (level <= 30) {
        return {
            level,
            shapes: SHAPES_ALL,
            rotations: ROTATIONS_FULL,
            mirrorRatio: 0.5,
            label: 'Rotations fines',
        };
    }
    if (level <= 40) {
        return {
            level,
            shapes: SHAPES_ALL,
            rotations: ROTATIONS_FULL,
            mirrorRatio: 0.55,
            label: 'Pression temporelle',
        };
    }
    return {
        level,
        shapes: SHAPES_ALL,
        rotations: ROTATIONS_FULL,
        mirrorRatio: 0.6,
        label: 'Filtrage expert',
    };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
export const timing = {
    fixationMs: 400,
    /** Gap entre les deux stimuli (ms). */
    gapMs: 350,
    feedbackMs: 200,
    itiMs: 600,
    /** Fenêtre de réponse maximale après l'affichage du second stimulus. */
    responseWindowMs: 2200,
};
export const paradigmMeta = {
    slug: 'minds-eye',
    paradigm: 'Mental rotation 2D (Cooper & Shepard 1973)',
    /** Internal only — non affiché. */
    masterMage: 'Garek · Volta',
    category: 'terre_navigation',
    goal: 'Rotation mentale : la forme tournée correspond-elle à la référence, ou est-ce son miroir ?',
};
//# sourceMappingURL=params.js.map